/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
  Label,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import Nvl from 'loracoms/Nvl';
import PageSizer from 'loracoms/PageSizer';
import PanelToolbar from 'loracoms/PanelToolbar';
import DatePicker from 'loracoms/DatePicker';
import { getAppLogs } from 'loraapi/lora_device';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const defaultFrom = () => startOfDay(subDays(new Date(), 7));
const defaultTo = () => endOfDay(new Date());

const propTypes = {
  appId: React.PropTypes.string.isRequired,
  app: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
};

const kLimit = 10;

class LogView extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      list: [],
      pageSize: kLimit,
      from: defaultFrom(),
      to: defaultTo(),
      mark: 0,
    };
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.logview');
    this.limit = kLimit;
    this.from = defaultFrom();
    this.to = defaultTo();
  }

  componentDidMount() {
    this.loadLogs();
  }

  componentWillReceiveProps(nextProps) {
    const { app } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
  }

  loadLogs() {
    const { appId } = this.props;
    const params = {
      order: 'desc',
      after: this.from.valueOf(),
      before: this.to.valueOf(),
      limit: this.limit,
      mark: this.mark,
    };
    getAppLogs(appId, params).then((resp) => {
      const res = resp.body;
      this.setState({ list: res.list, more: res.more, mark: this.mark, status: 'success' });
    }).catch(() => {});
  }

  handleChangePageSize(ps) {
    this.limit = ps;
    this.setState({ pageSize: ps });
    this.loadLogs();
  }

  handleChangeFrom(d) {
    const from = startOfDay(d);
    this.setState({ from, to: endOfDay(d) });
    this.from = from;
    this.loadLogs();
  }

  handleChangeTo(d) {
    const to = endOfDay(d);
    this.setState({ to });
    this.to = to;
    this.loadLogs();
  }

  render() {
    const { pushState } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
      pageSize,
      app,
    } = this.state;
    const { data: appData = {} } = app;

    const breadcrumb = [{
      content: this.intlMsg.msg('application', 'application.breadcrumb'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appData.name} status={app.status} />,
      active: true,
    }];

    const fromPicker = <DatePicker date={from} onSelect={this.handleChangeFrom} />;
    const toPicker = (
      <DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => LogView.handleDisableDate(d, from)}
      />
    );

    const LogLevels = {
      error: <Label bsStyle="danger">ERROR</Label>,
      info: <Label bsStyle="info">INFO</Label>,
      warn: <Label bsStyle="warning">WARN</Label>,
      debug: <Label bsStyle="default">DEBUG</Label>,
    };

    const trs = this.state.list.map((l, idx) => {
      const info = l.info || {};
      const infos = _.map(Object.keys(info), k => (
        <span className={styles.parsed}>
          <span className={styles.key}>{k}</span>
          <span className={styles.value}>{info[k]}</span>
        </span>
      ));

      return (
        <tr key={String(idx)}>
          <td className={styles.loglevel}>{LogLevels[l.cat]}</td>
          <td>{format(l.$time, 'YYYY-MM-DD HH:mm:ss')}</td>
          <td>
            <RichLabel content={l.code} />
          </td>
          <td>
            <Link
              onClick={() => pushState(`/application/${appData.id}/devices/${l.deveui}`)}
            >
              {normalizeDevEUI(l.deveui)}
            </Link>
          </td>
          <td>{infos}</td>
        </tr>
      );
    });

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Panel bsStyle="aisz-white" header={this.intlMsg.msg('panelheader')}>
                <PanelToolbar tools={[fromPicker, toPicker]} />
                <Table className="aisz-table-light" striped hover bordered responsive>
                  <thead>
                    <tr>
                      <th className={styles.loglevel}>
                        {this.intlMsg.msg('thead.loglevel')}
                      </th>
                      <th> {this.intlMsg.msg('thead.time')} </th>
                      <th> {this.intlMsg.msg('thead.code')} </th>
                      <th>DevEUI</th>
                      <th> {this.intlMsg.msg('thead.remark')} </th>
                    </tr>
                  </thead>
                  <tbody>
                    {trs}
                  </tbody>
                </Table>
                <div className={`${styles.pager} clearfix`}>
                  <PageSizer
                    pageSize={pageSize}
                    onChange={this.handleChangePageSize}
                    options={[10, 20, 50, 100]}
                  />
                </div>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

LogView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  app: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LogView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/LogView/index.jsx